import React from 'react';
import { MapPin, Phone, Mail, Linkedin, Instagram, Facebook, Twitter, Youtube } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const Footer = () => {
  const { language } = useLanguage();
  
  const footerContent = {
    tr: {
      contactTitle: 'Talep ve sorularınız için bizimle iletişime geçebilirsiniz.',
      headquarters: 'Genel Merkez',
      copyright: 'Tüm hakları saklıdır.'
    },
    en: {
      contactTitle: 'You can contact us for your requests and questions.',
      headquarters: 'Headquarters',
      copyright: 'All rights reserved.'
    }
  };

  const content = footerContent[language];
  
  return (
    <footer id="contact" className="bg-[#36344D] text-white pt-16 pb-8">
      <div className="container mx-auto px-4 lg:px-8">
        {/* Google Maps Section */}
        <div className="mb-12">
          <h3 className="text-2xl font-bold mb-6 text-[#DF6A6A]">{content.headquarters}</h3>
          <div className="grid lg:grid-cols-2 gap-8">
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6">
              <div className="space-y-4">
                <div className="flex items-start space-x-3">
                  <MapPin className="w-6 h-6 text-[#DF6A6A] flex-shrink-0 mt-1" />
                  <div>
                    <p className="font-semibold text-lg mb-1">{content.headquarters}</p>
                    <p className="text-gray-300">Barış, Akdeniz Cd. No:8 D:57, 34520 Beylikdüzü/İstanbul</p>
                  </div>
                </div>
                <div className="flex items-center space-x-3">
                  <Phone className="w-6 h-6 text-[#DF6A6A]" />
                  <a href="tel:02129780978" className="hover:text-[#DF6A6A] transition-colors text-lg">
                    0212 978 09 78
                  </a>
                </div>
                <div className="flex items-center space-x-3">
                  <Mail className="w-6 h-6 text-[#DF6A6A]" />
                  <a href="mailto:info@moventlog.com" className="hover:text-[#DF6A6A] transition-colors text-lg">
                    info@moventlog.com
                  </a>
                </div>
              </div>
            </div>
            
            {/* Google Maps Embed */}
            <div className="rounded-lg overflow-hidden shadow-xl h-80">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3009.8886888429247!2d28.638237276546443!3d41.00345597134076!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14caa47e0c0e6c5f%3A0x5c5c5c5c5c5c5c5c!2zQmFyxLHFnyBNYWgsIEFrZGVuaXogQ2QuIE5vOjggRDo1NywgMzQ1MjAgQmV5bGlrZMO8esO8L8Swc3RhbmJ1bA!5e0!3m2!1str!2str!4v1705072800000!5m2!1str!2str"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Movent Logistics Location"
              ></iframe>
            </div>
          </div>
        </div>

        {/* Top Section */}
        <div className="mb-12 border-t border-white/10 pt-8">
          <h3 className="text-2xl font-bold mb-6">{content.contactTitle}</h3>
        </div>

        {/* Social Media Links */}
        <div className="flex justify-center space-x-6 mb-8 pb-8 border-b border-white/10">
          <a href="https://www.linkedin.com/company/movent-logistics-solutions/" target="_blank" rel="noopener noreferrer" className="hover:text-[#DF6A6A] transition-colors">
            <Linkedin className="w-6 h-6" />
          </a>
          <a href="https://instagram.com/movent.logistics" target="_blank" rel="noopener noreferrer" className="hover:text-[#DF6A6A] transition-colors">
            <Instagram className="w-6 h-6" />
          </a>
          <a href="https://facebook.com/moventlogistics" target="_blank" rel="noopener noreferrer" className="hover:text-[#DF6A6A] transition-colors">
            <Facebook className="w-6 h-6" />
          </a>
          <a href="https://twitter.com/moventlogistics" target="_blank" rel="noopener noreferrer" className="hover:text-[#DF6A6A] transition-colors">
            <Twitter className="w-6 h-6" />
          </a>
          <a href="https://youtube.com/@moventlogistics" target="_blank" rel="noopener noreferrer" className="hover:text-[#DF6A6A] transition-colors">
            <Youtube className="w-6 h-6" />
          </a>
        </div>

        {/* Copyright */}
        <div className="text-center text-sm text-gray-400">
          <p>© 2025 Movent Logistics. {content.copyright}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;